<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">

        <header class="site-manager-head-con" style="padding-top: 20px">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="studentDisplayName" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="idCard" placeholder="请输入证件号码" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="certificateNumber" placeholder="请输入证书编号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="certificateType" placeholder="请选择证书类型" clearable @change="getItcCertificateList">
                        <el-option label="物流管理职业技能等级证书" value="物流管理职业技能等级证书"></el-option>
                        <el-option label="供应链运营职业技能等级证书" value="供应链运营职业技能等级证书"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-select v-model="searchAuditStatus" clearable placeholder="请选择审核状态" @change="getItcCertificateList">
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="审核通过(未颁证)" :value="1"></el-option>
                        <el-option label="审核未通过" :value="2"></el-option>
                        <el-option label="审核通过(已申请纸质证书)" :value="3"></el-option>
                        <el-option label="审核通过且颁证" :value="4"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-select v-model="certificateBatchId" clearable placeholder="请选择证书批次">
                        <el-option v-for="item in batchList" :key="item.id" :label="item.batchName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getItcCertificateList()">搜索</el-button>
                    <a class="export-button-a" style="color:#fff;margin-left:10px;" :href="exportPaperExam">导出</a>
                    <!-- <el-button type="primary" icon="el-icon-delete" @click="DeleteAllDialogVisible = true">删除</el-button> -->
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left: 30px">
            <el-table :data="list" ref="multipleeeeTable"
                :row-key="getRowKeys">
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="studentDisplayName" label="姓名"></el-table-column>
                <el-table-column prop="studentPinYin" label="姓名拼音"></el-table-column>
                <el-table-column prop="unitName" label="考核点"></el-table-column>
                <el-table-column prop="idType" label="证件类型"></el-table-column>
                <el-table-column prop="idCard" label="证件号码"></el-table-column>
                <el-table-column prop="certificateNumber" label="证书编号"></el-table-column>
                <el-table-column prop="certificateName" label="证书名称"></el-table-column>
                <el-table-column prop="certificateType" label="证书类型"></el-table-column>
                <el-table-column prop="certificateLevel" label="证书等级"></el-table-column>
                <el-table-column prop="certificateIssueDate" label="证书签发日期"></el-table-column>
                <el-table-column prop="certificateBatchName" label="证书批次"></el-table-column>
                <el-table-column prop="examName" label="申请状态">
                    <template slot-scope="scope">
                        <span style="color:green" v-if="scope.row.paperCertApplyState == 1">已申请</span>
                        <span style="color:red" v-else>未申请</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="studentUrl" label="照片">
                    <template slot-scope="scope">
                        <el-popover v-if="scope.row.studentUrl !=''"
                        placement="right"
                        width="400"
                        trigger="hover">
                        <img :src="scope.row.studentUrl" style="width: 400px;"/>
                        <img :src="scope.row.studentUrl" style="width: 100px;" slot="reference"/>
                        </el-popover>
                        <span v-else>暂无照片</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.paperCertApplyState==1" size="mini" type="primary" @click="handleApply(scope.row)">修改申请信息</el-button>
                        <el-button v-else size="mini" type="primary" @click="handleApply(scope.row)">申请纸质证书</el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="u-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler"
                    :current-page="page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount" v-show="totalCount > 0"
                    style="text-align: center"></el-pagination>
            </div>
        </div>

        <el-dialog :title="titleFormVisible" :visible.sync="dialogFormVisible" :append-to-body="true" width="800px">
            <el-form :inline="true" :model="form" class="demo-form-inline" size="small" label-width="120px"
                :rules="rules">
                <el-form-item label="证书批次">
                    <span>{{ form.certificateBatchName }}</span>
                </el-form-item>
                <el-form-item label="姓名" prop="studentDisplayName">
                    <el-input v-model="form.studentDisplayName" disabled></el-input>
                </el-form-item>
                <el-form-item label="姓名拼音" prop="studentPinYin">
                    <el-input v-model="form.studentPinYin" disabled></el-input>
                </el-form-item>
                <el-form-item label="证件号码" prop="idCard">
                    <el-input v-model="form.idCard" disabled></el-input>
                </el-form-item>
                <!-- <el-form-item label="证书名称" prop="certificateName">
                    <el-input v-model="form.certificateName"></el-input>
                </el-form-item>
                <el-form-item label="证书编号" prop="certificateNumber">
                    <el-input v-model="form.certificateNumber"></el-input>
                </el-form-item> -->
                <el-form-item label="证书类型" prop="certificateType">
                    <el-select v-model="form.certificateType" placeholder="请选择" disabled>
                        <el-option label="物流管理职业技能等级证书" value="物流管理职业技能等级证书"></el-option>
                        <el-option label="供应链运营职业技能等级证书" value="供应链运营职业技能等级证书"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书等级" prop="certificateLevel">
                    <el-select v-model="form.certificateLevel" placeholder="请选择" disabled>
                        <el-option label="初级" value="初级"></el-option>
                        <el-option label="中级" value="中级"></el-option>
                        <el-option label="高级" value="高级"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="收件人姓名" prop="paperCertPostDisplayName">
                    <el-input v-model="form.paperCertPostDisplayName"></el-input>
                </el-form-item>

                <el-form-item label="收件人手机号" prop="paperCertPostMobile">
                    <el-input v-model="form.paperCertPostMobile"></el-input>
                </el-form-item>

                <el-form-item label="收件地址" prop="paperCertPostAddress">
                    <el-input type="textarea" v-model="form.paperCertPostAddress" style="width:500px"></el-input>
                    <p style="color:red">注意：纸质版证书的申请流程大约需要3个月的时间。</p>
                    <p style="color:red">在填写相关信息时，请务必确保收件信息准确无误，且为3个月内可收件地址。</p>

                </el-form-item>

                <el-table-column prop="examName" label="付款码">
                    <div style="display: flex; align-items: flex-end;">
                    <img style="margin-left:100px;width:200px;height:240px;border:1px solid #ccc;" src="https://file.clpp.org.cn/ykt/ori/x2mmalko-6tl1m-yxtdsjw/aWRx7AEDcJADxbxB.jpg" />
                    <div style="margin-left:10px;margin-bottom: 20px;">
                        <p style="color:#000;font-weight: bold;font-size:18px;">付款须知：</p>

                    <p style="color:red;font-size:15px;">1、申领纸质证书的费用为100元/人</p>
                    <p style="color:red;font-size:15px;">2、扫码付款时，请填写{{form.studentDisplayName}}的身份证号:{{ form.idCard }}</p>
                    <p style="color:red;font-size:15px;">3、如有其他问题，请联系管理办公室：马老师 010-83775926，徐老师010-83775907</p>

                    </div>    
                </div>
                </el-table-column>

                <!-- <el-form-item label="证书签发日期" prop="certificateIssueDate">
                    <el-date-picker
                        v-model="form.certificateIssueDate"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item> -->

                <!-- <el-form-item label="证件头像">
                    <imageUpload class="img_upload" :url="urlAliyunOSS" :files.sync="form.studentUrl" v-if="dialogFormVisible" format="image"></imageUpload>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="applyStuPaperItcCert()">提交申请</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { FaceTeachPerformance } from "@/api/v1.faceteachactivity";
import imageUpload from "components/imageUpload.vue";
import stuActivtyUpload from "components/stuActivtyUpload.vue";
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            studentDisplayName: "",
            idCard: "",
            certificateNumber: "",
            examName: "",
            certificateType: "",
            certificateBatchId: "",
            searchAuditStatus: "",
            schoolName: "",
            list: [],
            form: {
                id: "",
                studentDisplayName: "",
                unitName: "",
                idType: "",
                idCard: "",
                studentPinYin: "",
                studentUrl: "",
                certificateNumber: "",
                certificateName: "",
                certificateType: "",
                certificateBatchId: "",
                certificateLevel: "",
                certificateIssueDate: "",
                certificateBatchName: "",
                paperCertPostAddress:"",
                paperCertPostMobile:"",
                paperCertPostDisplayName:""
            },
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            //编辑信息
            titleFormVisible: "",
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            // uploadUrl: "/api/XOrg/ItcCertificateMag/uploadExcelPro",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: "",
            batchList: [],
            searCertGradeList: [],
            // 导入结果
            inportcertificateBatchId: "",
            dataResultVisible: false,
            wordUrl: "/public/docs/IFPSM证书信息导入模板.xlsx",
            count: 0,
            successNum: 0,
            successFileName: "",
            failNum: 0,
            failFileName: "",
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
            //
            percentageVisible: false,
            percentage: 0,
            taskId: "",
            timer: null,
            ids: [],
            importRule: {
                inportcertificateBatchId: [
                    { required: true, message: '请选择证书批次', trigger: 'blur' }
                ]
            },
            // 头像上传
            touXiangDialog: false,
            TisiDialog: false,
            tisiList: [],
            // 获取row的key值
            getRowKeys(row) {
                return row.id;
            },
            rules: {
                paperCertPostDisplayName: [
                    { required: true, message: '请输入收件人姓名', trigger: 'blur' }
                ],
                paperCertPostMobile: [
                    { required: true, message: '请输入收件人手机号', trigger: 'blur' }
                ]
            },
            // 审核
            auditIds: [],
            auditStatus: 0,
            auditOpinion: "",
            auditDialogVisible: false
        };
    },
    props: {
        schoolId: {
            type: String,
            default: ""
        }
    },
    components: {
        imageUpload,
        stuActivtyUpload
    },
    computed: {
        exportPaperExam()
        {
            return "/api/XOrg/ItcCertificateMag/exportStuItcExcel?studentDisplayName=" +
                this.studentDisplayName +
                "&idCard=" +
                this.idCard +
                "&certificateNumber=" +
                this.certificateNumber +
                "&certificateType=" +
                this.certificateType +
                "&certificateBatchId=" +
                this.certificateBatchId;
        },
    },
    created() {
        this.getItcBatchList();
        this.getItcCertificateList();
    },
    watch: {
    },
    methods: {
        cancelInfo() {
            this.form.id = "";
            this.form.studentDisplayName = "";
            this.form.unitName = "";
            this.form.idType = "";
            this.form.idCard = "";
            this.form.studentPinYin = "";
            this.form.studentUrl = "";
            this.form.certificateNumber = "";
            this.form.certificateName = "";
            this.form.certificateType = "";
            this.form.certificateBatchId = "";
            this.form.certificateLevel = "";
            this.form.certificateIssueDate = "";
            this.form.paperCertPostAddress="";
            this.form.paperCertPostDisplayName="";
            this.form.paperCertPostMobile="";
            this.dialogFormVisible = false;
        },
        onSuccess(res) {
            var that = this;
            if (res.code > 0) {
                this.ImportDialogVisible = false;
                this.percentageVisible = true;
                this.taskId = res.taskId;
                this.timer = setInterval(function () {
                    that.$http
                        .post("/api/XOrg/ImportTask/getImportProgress", {
                            id: res.taskId,
                        })
                        .then(function (rst) {
                            if (rst.code > 0) {
                                that.percentage = rst.info.progressBar;
                                if (that.percentage == 100) {
                                    clearInterval(that.timer);
                                    that.failNum = rst.info.failNumber;
                                    that.successNum = rst.info.successNumber;
                                    that.count = rst.info.importCount;
                                    that.dataResultVisible = true;
                                    that.percentageVisible = false;
                                    that.percentage = 0;
                                    that.page = 1;
                                    that.cancel();
                                    that.getItcCertificateList();
                                }
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                }, 2000);
            } else {
                this.$message.warning(res.msg);
            }
        },
        //清除数据
        cancel() {
            this.ImportDialogVisible = false;
            this.inportcertificateBatchId = "";
            this.fileList = [];
        },
        addInfo() {
            this.titleFormVisible = "新增";
            this.dialogFormVisible = true;
        },
        //编辑
        applyStuPaperItcCert() {
            var that = this;
            this.$http
                .post("/api/XOrg/stuItcCertificate/applyStuPaperItcCert", {
                    itcId: this.form.id,
                    paperCertPostDisplayName: this.form.paperCertPostDisplayName,
                    paperCertPostMobile: this.form.paperCertPostMobile,
                    paperCertPostAddress: this.form.paperCertPostAddress,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getItcCertificateList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //弹出框赋值
        handleApply(row) {
            this.form.id = row.id;
            this.form.studentDisplayName = row.studentDisplayName;
            this.form.unitName = row.unitName;
            this.form.idType = row.idType;
            this.form.idCard = row.idCard;
            this.form.studentPinYin = row.studentPinYin;
            this.form.studentUrl = row.studentUrl;
            this.form.certificateNumber = row.certificateNumber;
            this.form.certificateName = row.certificateName;
            this.form.certificateType = row.certificateType;
            this.form.certificateBatchId = row.certificateBatchId;
            this.form.certificateLevel = row.certificateLevel;
            this.form.certificateIssueDate = row.certificateIssueDate;
            this.form.certificateBatchName = row.certificateBatchName;
            this.form.paperCertPostAddress=row.paperCertPostAddress;
            this.form.paperCertPostMobile=row.paperCertPostMobile;
            this.form.paperCertPostDisplayName=row.paperCertPostDisplayName;
            this.titleFormVisible = "申请纸质证书";
            this.dialogFormVisible = true;
        },
        //查询
        getItcCertificateList() {
            var that = this;
            this.$http
                .post("/api/XOrg/stuItcCertificate/getItcCertificateList", {
                    studentDisplayName: this.studentDisplayName,
                    idCard: this.idCard,
                    certificateNumber: this.certificateNumber,
                    examName: this.examName,
                    certificateType: this.certificateType,
                    certificateBatchId: this.certificateBatchId,
                    auditStatus: this.searchAuditStatus,
                    schoolId: this.schoolId,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.schoolName = rst.schoolName;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getItcBatchList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateBatch/getItcBatchList", {
                    type: 0,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.batchList = rst.batchList;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getItcCertificateList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getItcCertificateList();
        }
    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }

    .export-button-a {
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2f7dff;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1a2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #d8e0e6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #e65b72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #ee6c3a;
        border-color: #ee6c3a;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
